const STORAGE_KEY = 'np_admin_notifications_read_v1';

function readStore() {
  if (typeof window === 'undefined') return { ids: [] };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ids: [] };
    const parsed = JSON.parse(raw);
    return { ids: Array.isArray(parsed?.ids) ? parsed.ids.map(String) : [] };
  } catch {
    return { ids: [] };
  }
}

function writeStore(ids) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ids: [...new Set(ids.map(String))] }));
}

export function getReadNotificationIds() {
  return new Set(readStore().ids);
}

export function markNotificationRead(id) {
  if (!id) return;
  const ids = readStore().ids;
  if (!ids.includes(String(id))) {
    writeStore([...ids, String(id)]);
  }
}

export function markAllNotificationsRead(notificationIds) {
  const ids = readStore().ids;
  const merged = [...ids, ...notificationIds.map(String)];
  writeStore(merged);
}

export function clearReadNotifications() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(STORAGE_KEY);
}
